var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceptionact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1249 14.9846L12.01 20.9433L6.7132 15.0027C2.93616 15.4607 0 18.6861 0 22.5847V23.2873H24V22.5847C24 18.6306 20.9797 15.3687 17.1249 14.9846ZM19.8277 21.1328H15.6121V19.7277H19.8277V21.1328Z",
    fill: "#004276"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.54562 14.9467L11.99 18.8096L15.3058 14.9467H8.54562ZM12 0.712646C8.4335 0.712646 5.53198 3.61421 5.53198 7.18065C5.53198 10.7472 8.4335 13.6487 12 13.6487C15.5665 13.6487 18.4681 10.7471 18.4681 7.18065C18.4681 3.61421 15.5666 0.712646 12 0.712646Z",
    fill: "#004276"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceptionact);
export default __webpack_public_path__ + "static/media/receptionact.74d1952d56c21a8fd1b7992372f1f20d.svg";
export { ForwardRef as ReactComponent };